var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      _vm._b(
        { staticClass: "base-loading-skeleton", class: _vm.componentClass },
        "div",
        _vm.componentAttrs,
        false
      )
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }